module.exports = __webpack_public_path__ + "static/media/image_4.2f138105.svg";